import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";

interface DetailPaneStubProps {
  agentName: string;
  interactionId: string;
  onPullBack: () => void;
  onFocusWindow: () => void;
}

export default function DetailPaneStub({ agentName, interactionId, onPullBack, onFocusWindow }: Readonly<DetailPaneStubProps>) {
  return (
    <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", height: "100%", p: 3, textAlign: "center" }}>
      <OpenInNewIcon sx={{ fontSize: 40, mb: 1, opacity: 0.5 }} />
      <Typography variant="subtitle1" fontWeight={600}>Viewing in separate window</Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 0.25 }}>{agentName}</Typography>
      <Typography variant="caption" sx={{ fontFamily: "var(--font-mono)", opacity: 0.6, mb: 2 }}>{interactionId}</Typography>
      <Box sx={{ display: "flex", gap: 1 }}>
        <Button variant="outlined" size="small" onClick={onPullBack}>Pull Back</Button>
        <Button variant="text" size="small" onClick={onFocusWindow}>Focus Window</Button>
      </Box>
    </Box>
  );
}
